/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Content_PlaceholderInputs */

const en_admin_posts_content_placeholder = /** @type {(inputs: Admin_Posts_Content_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write your post…`)
};

/**
* | output |
* | --- |
* | "Write your post…" |
*
* @param {Admin_Posts_Content_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_content_placeholder = /** @type {((inputs?: Admin_Posts_Content_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Content_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_content_placeholder(inputs)
});
export { admin_posts_content_placeholder as "admin.posts.content_placeholder" }